/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".agente-options[_ngcontent-%COMP%]{max-height:280px;overflow:auto}.agente-name[_ngcontent-%COMP%]{width:550px;font-size:1.3rem!important}input[type=radio][_ngcontent-%COMP%]{width:26px;height:26px;margin:6px 15px 6px 0;vertical-align:middle}"];
export { styles as styles };
